<template>
  <div class="card is-min-width-800">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('addEditTypeTaxationTlpe.popUpDuplicate.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'addEditTypeTaxationTlpe.error.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="columns is-multiline">
        <b-field :label="$t('addEditTypeTaxationTlpe.popUpDuplicate.anneeACopier')"
                 class="column is-6 mgb-0">
          <b-input v-model="anneeCopie" type="number"></b-input>
        </b-field>
        <b-field :label="$t('addEditTypeTaxationTlpe.popUpDuplicate.anneeACreer')"
                 class="column is-6 mgb-0">
          <b-input v-model="anneeDestination" type="number"></b-input>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('addEditTypeTaxationTlpe.popUpDuplicate.actions.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="updateTypesTaxationTlpe()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { update } from '@/api/typeTaxationTlpe';
import validationTypeTaxationTlpe from '@/services/parametrage/validation/validationTypeTaxationTlpe';
import validation from '@/services/validation/validation';
import translator from '@/services/parametrage/translator/translatorTypeTaxationTlpe';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    typesTaxeTlpeSelected: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      typesTaxeTlpe: [],
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      anneeCopie: null,
      anneeDestination: null,
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    async updateTypesTaxationTlpe() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        const promiseUpdate = [];
        this.typesTaxeTlpe.forEach((typeTaxationTlpe) => {
          const typeTaxationTlpeLigneACopier = typeTaxationTlpe.typeTaxationTlpeLignes
            .find((ligne) => {
              return ligne.anneeCivile === Number(this.anneeCopie);
            });
          if (!typeTaxationTlpeLigneACopier
            || typeTaxationTlpe.typeTaxationTlpeLignes.find((ligne) => {
              return ligne.anneeCivile === Number(this.anneeDestination);
            })) return;
          typeTaxationTlpe.typeTaxationTlpeLignes.push({
            anneeCivile: this.anneeDestination,
            montantAnnuel: typeTaxationTlpeLigneACopier.montantAnnuel,
            montantSemaine: typeTaxationTlpeLigneACopier.montantSemaine,
          });
          promiseUpdate.push(update(typeTaxationTlpe));
        });
        await Promise.all(promiseUpdate);
        messageSuccess(this.$i18n.t('addEditTypeTaxationTlpe.success.dupliquer'));
        this.$emit('reloadTypeTaxationTlpe');
        this.$parent.close();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationTypeTaxationTlpe(e.response, this.messages);
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translator);
          this.error = true;
          loadingComponent.close();
          this.typesTaxeTlpe = cloneDeep(this.typesTaxeTlpeSelected);
          return;
        }
        messageErreur(this.$i18n);
        this.typesTaxeTlpe = cloneDeep(this.typesTaxeTlpeSelected);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.typesTaxeTlpe = cloneDeep(this.typesTaxeTlpeSelected);
  },
};
</script>
